// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2Ssa8","footer":"ModalFilter_footer__qH055"};